import React, { useState } from 'react'
import { useHistory, useParams, useLocation } from "react-router-dom";

import Header                   from '../../components/header/index.js'
import Footer                   from '../../components/footer/index.js'
import ManualFileApproval       from '../../components/manualFileApproval/index.js'

const ApprovalManualFile = () => {

    return (
        <div>
            <Header />

            <ManualFileApproval />

            <Footer />
        </div>
    );
}

export default ApprovalManualFile;